import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginWithLambda } from '../repository/authRepository';
import { setupAutoRefresh } from '../utils/tokenRefresh';

interface LoginProps {
    onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await loginWithLambda({ username, password });

        if ('error' in result) {
            setError(result.error);
            setLoading(false);
            return;
        }

        localStorage.setItem('access_token', result.access);
        localStorage.setItem('refresh_token', result.refresh);
        localStorage.setItem('user', JSON.stringify(result.user));

        setupAutoRefresh();
        onLoginSuccess();
        navigate('/');
        setLoading(false);
    };

    return (
        <div className="auth-container">
            <h2>Log In</h2>
            <form onSubmit={handleSubmit} className="auth-form">
                {error && <div className="error-message">{error}</div>}
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        disabled={loading}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={loading}
                    />
                </div>
                <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Logging in...' : 'Log In'}
                </button>
            </form>
            <p className="auth-link">
                Don't have an account? <Link to="/signup">Sign up</Link>
                {' · '}
                <Link to="/reset-password">Forgot password?</Link>
            </p>
        </div>
    );
};

export default Login;
